import { FilterValues } from "../../../data-model/filterValues";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { useFilterAndSearchEffect } from "./useFilterAndSearchEffect";
import {
  NycbsExternalFilterPayload,
  useFilterPayload,
} from "./useFilterPayload";
import { usePaginationReset } from "./usePaginationReset";
import { NycbsExternalTableState } from "../types/nycbsExternalTableState";
import { useSearchTerm } from "./useSearchTerm";
import { useValidFilters } from "./useValidFilters";

export interface UseFilterAndSearchReturn {
  filterPayload: NycbsExternalFilterPayload | null;
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  paginationResetCount: number;
  validFilters: FilterValues[];
}

export const useFilterAndSearch = (
  initialDataFetchingExecuted: boolean,
  setTableData: React.Dispatch<React.SetStateAction<PharmaStpFileModel[]>>,
  setNycbsExternalState: React.Dispatch<
    React.SetStateAction<NycbsExternalTableState>
  >,
  dateFromStart: string,
  dateFromEnd: string,
  pageSize: number = 120,
  orgId: string,
): UseFilterAndSearchReturn => {
  const { searchTerm, setSearchTerm } = useSearchTerm();

  const { paginationResetCount, setPaginationResetCount } =
    usePaginationReset();

  const validFilters = useValidFilters();

  const { filterPayload } = useFilterPayload(
    validFilters,
    searchTerm,
    initialDataFetchingExecuted,
    dateFromStart,
    dateFromEnd,
    pageSize,
    orgId,
  );

  useFilterAndSearchEffect(
    filterPayload,
    initialDataFetchingExecuted,
    setTableData,
    setNycbsExternalState,
    setPaginationResetCount,
  );

  return {
    filterPayload,
    searchTerm,
    setSearchTerm,
    paginationResetCount,
    validFilters,
  };
};
